<template>
  <NsOktaPassword
    v-model="model"
    class="df-password"
    :translations="translations"
    :rules-on="true"
    :username="username"
  />
</template>

<script>
/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { StringService } from '@nuskin/ns-util';
import { PropsMixin, LocaleMixin, ModelMixin } from '../mixins';
import NsOktaPassword from '../../NsOktaPassword.vue';

const STRINGS_WE_NEED = [
  'criteriaComplete',
  'dontIncludeNames',
  'dontReusePassword',
  'excludesWhitespaceChars',
  'hide',
  'includes8chars',
  'includesLower',
  'includesNumber',
  'includesSpecialChars',
  'includesUpper',
  'newPassword',
  'passwordConditionsMet',
  'passwordRequired',
  'show',
  ' usernameCantBePassword',
];

export default {
  name: 'NsInputPasswordField',
  components: {
    NsOktaPassword,
  },
  mixins: [PropsMixin, LocaleMixin, ModelMixin({ deep: false })],
  props: {
    /**
     * Field value
     * @type {Object}
     */
    value: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      translations: undefined,
      translationsPromise: null,
    };
  },
  watch: {
    locale: {
      immediate: true,
      handler(value) {
        this.loadCommonStrings(value);
      },
    },
  },
  methods: {
    loadCommonStrings(locale) {
      this.translationsPromise = (async () => {
        try {
          const strings = await StringService.getStrings(
            STRINGS_WE_NEED.map((key) => ({ key })),
            locale
          );
          if (this.schema.label) {
            strings.newPassword = this.schema.label;
            strings.changePassword = this.schema.label;
          }
          strings.includes8Chars =
            strings.includes8chars || strings.includes8Chars;

          this.translations = strings;
        } catch (err) {
          /* istanbul ignore next */
          // eslint-disable-next-line no-console
          console.error('error loading password strings', err);
        } finally {
          this.translationsPromise = null;
        }
      })();
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

$color-dryink: map.get(colors.$baseColors, dryink);
$color-success: map.get(colors.$baseColors, success);
$color-white: #ffffff;

.df-password {
  ::v-deep {
    .v-input__control input {
      background-color: $color-white;
      border: 1px solid $color-dryink !important;
    }
  }
}
</style>
